import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPeopleTrustUs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M60 58v-4c0-3.728-2.55-6.86-6-7.748m-7-23.67a8.003 8.003 0 0 1 0 14.837M50 58c0-3.727 0-5.591-.609-7.062a8 8 0 0 0-4.33-4.329C43.592 46 41.728 46 38 46h-6c-3.727 0-5.591 0-7.061.609a8 8 0 0 0-4.33 4.33C20 52.409 20 54.273 20 58m23-28a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
    />
  </svg>
);
export default SvgPeopleTrustUs;
